import { connect } from 'react-redux'
import { pauseApp, resumeApp } from '../actions/pauseResume'
import PauseResumePresentation from '../presentations/PauseResume/PauseResumePresentation'

const mapDispatchToProps = (dispatch:Function) => ({
    // the visibility state doesnt come with the event, we have to check document.visibilityState
    handleVisibilityChange: () => document.visibilityState==='visible' ? dispatch(resumeApp()) : dispatch(pauseApp())
})

// we donst need to map any state to props, dispatch only
export default connect(null, mapDispatchToProps)(PauseResumePresentation)
